export default __webpack_public_path__ + "static/media/steve_trumble.004f9c8c.jpg";